<template>
  <!-- display:contents so the button is a direct flex child of the app-bar row,
       matching the sibling icon buttons (spacing + no-bg come from me-3/no-bg,
       same as AppBarThemeSwitcher/AppBarNotification). Only meaningful online:
       the content-layout navbar is never shown offline. -->
  <span v-if="!isForcedOffline" style="display: contents;">
    <v-btn
      class="me-3 no-bg"
      icon
      :aria-label="$t('evaluations.offline_lock_toggle_aria')"
      @click="dialog = true"
    >
      <v-icon>{{ icons.mdiWifi }}</v-icon>
    </v-btn>

    <confirm-dialog
      :value="dialog"
      :title="$t('evaluations.offline_lock_title')"
      :message="$t('evaluations.offline_lock_desc')"
      :confirm-text="$t('evaluations.offline_lock_cta')"
      confirm-color="secondary"
      @confirm="lockOffline"
      @close="dialog = false"
      @input="dialog = $event"
    ></confirm-dialog>
  </span>
</template>

<script>
import { mdiWifi } from '@mdi/js'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  name: 'OfflineLockToggle',
  components: { ConfirmDialog },
  data() {
    return {
      dialog: false,
      icons: { mdiWifi },
    }
  },
  computed: {
    isForcedOffline() {
      return this.$store.getters['offline/isForcedOffline']
    },
  },
  methods: {
    lockOffline() {
      this.dialog = false
      // Flip the effective online state, then funnel to the offline home. The
      // main.js watcher would also redirect, but we push here so the transition
      // is immediate and not dependent on watcher timing.
      this.$store.dispatch('offline/lockOffline')
      this.$router.push({ name: 'offline-home' }).catch(() => {})
    },
  },
}
</script>
